// extracted by mini-css-extract-plugin
module.exports = {"banner":"legal-module--banner--JdGQU","article":"legal-module--article--2Xj_1"};